// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.description {
    border: 1px solid lightgray;
    padding: 1px;
    margin-top: 5px;
    overflow: scroll;
}

.jiraicon {
    width: 24px;
    height: 24px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/common/jiracontrol/jira.control.css"],"names":[],"mappings":"AAAA;IACI,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":[".description {\n    border: 1px solid lightgray;\n    padding: 1px;\n    margin-top: 5px;\n    overflow: scroll;\n}\n\n.jiraicon {\n    width: 24px;\n    height: 24px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
